export default __webpack_public_path__ + "static/madrid-e60411dd67c26389c8308b7917f19ce7.jpg";